/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MeiTiGuangGaoWeiChaXunDTO,
  MeiTiGuangGaoWeiChuangJianDTO,
  MeiTiGuangGaoWeiGengXinDTO,
  ResponseApiIPageMeiTiGuangGaoWeiLieBiaoXiangYingDTO,
  ResponseApiLong,
  ResponseApiMeiTiGuangGaoWeiLieBiaoXiangYingDTO,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class MeiTiGuangGaoWeiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags MeiTiGuangGaoWeiGuanLi
   * @name CreatePublisherSlotUsingPost
   * @summary 创建媒体广告位
   * @request POST:/dsp-admin/api/publisher/slot/create
   * @secure
   */
  createPublisherSlotUsingPost = (
    createDTO: MeiTiGuangGaoWeiChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/slot/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuangGaoWeiGuanLi
   * @name PublisherSlotListUsingPost
   * @summary 分页查询媒体广告位列表
   * @request POST:/dsp-admin/api/publisher/slot/list
   * @secure
   */
  publisherSlotListUsingPost = (
    queryDTO: MeiTiGuangGaoWeiChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageMeiTiGuangGaoWeiLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/slot/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuangGaoWeiGuanLi
   * @name GetPublisherSlotByIdUsingGet
   * @summary 获取媒体广告位信息
   * @request GET:/dsp-admin/api/publisher/slot/{id}
   * @secure
   */
  getPublisherSlotByIdUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiMeiTiGuangGaoWeiLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/slot/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuangGaoWeiGuanLi
   * @name UpdatePublisherSlotUsingPut
   * @summary 更新媒体广告位
   * @request PUT:/dsp-admin/api/publisher/slot/{id}
   * @secure
   */
  updatePublisherSlotUsingPut = (
    updateDTO: MeiTiGuangGaoWeiGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/slot/${id}`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuangGaoWeiGuanLi
   * @name DeletePublisherSlotUsingDelete
   * @summary 删除媒体广告位
   * @request DELETE:/dsp-admin/api/publisher/slot/{id}
   * @secure
   */
  deletePublisherSlotUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/publisher/slot/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new MeiTiGuangGaoWeiGuanLi();
